module.exports = __webpack_public_path__ + "static/media/orange-up-arrow.fe6bf65a.svg";